
























import Vue from 'vue';
import pButton from '../p-button/p-button.vue';

type Button = InstanceType<typeof pButton>;

export default Vue.extend({
  extends: pButton,
  props: {
    value: { type: undefined, default: undefined },
    icon: { type: String, default: 'publish' },
    accept: { type: [String, Array], default: '*.*' },
    multiple: { type: Boolean, default: false },
    capture: {
      type: String,
      default: 'environment',
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/capture
      validator: (value) => value === 'environment' || value === 'user',
    },
  },
  computed: {
    computedAccept() {
      if (Array.isArray(this.accept)) {
        return this.accept.join(',').replace(/\*\./g, '.');
      }
      return this.accept.replace(/\*\./g, '.');
    },
    button(): Button {
      return (this as any) as Button;
    },
    fileSelectionClassList(): Record<string, boolean> {
      const buttonClassList = this.button.classList;
      buttonClassList['keyboard-focus'] = this.button.navigatedUsingKeyboard;
      return buttonClassList;
    },
  },
  methods: {
    onKeyUp() {
      this.button.navigatedUsingKeyboard = true;
    },
    onBlur() {
      this.button.navigatedUsingKeyboard = false;
    },
    // This has to be @change event to work on all browsers
    onFileChosen(files: FileList) {
      if (this.multiple) {
        // Needs a spread as this is actually a special FileList type and not an array
        this.$emit('input', [...files]);
      } else {
        this.$emit('input', files[0]);
      }
      // Reset value, otherwise if user selects same file twice consecutively the event is not fired
      const input = this.$refs.inputFile as any;
      input.value = null;
      this.button.navigatedUsingKeyboard = true;
    },
  },
});
